import type { CreateWebhookConfig, WebhookConfig } from '../outgoing-webhooks/webhook-config.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class WebhookConfigFactory extends ObjectFactory<WebhookConfig> {
  protected getDefaults(): WebhookConfig {
    return {
      ...baseDocumentFactory.build(),
      active: true,
      events: ['on-site-created'],
      identifiers: { shipperCode: 'default-shipper' },
      name: 'My Webhook',
      url: 'https://example.com/webhook',
    };
  }

  /** Build a CreateWebhookConfig body (no base document fields). */
  buildCreate(overrides: Partial<CreateWebhookConfig> = {}): CreateWebhookConfig {
    return {
      active: true,
      events: ['on-site-created'],
      identifiers: { shipperCode: 'default-shipper' },
      name: 'My Webhook',
      url: 'https://example.com/webhook',
      ...overrides,
    };
  }
}

export const webhookConfigFactory = new WebhookConfigFactory();
